import { createFileRoute } from '@tanstack/react-router';
import { ProviderConfigSettings } from '@/components/companies/provider-config-settings';

const VISITOR_COMPANY_SLOTS = [
  { slot: 'visitor_company', label: 'Company resolution' },
];

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/visitor-id/configuration',
)({
  component: () => (
    <ProviderConfigSettings
      header={false}
      slots={VISITOR_COMPANY_SLOTS}
      title="Company Resolution Providers"
      description="Order the reverse-IP company waterfall: earlier providers run first; a no-match (or error) falls through to the next. Leave Org blank for the global default."
    />
  ),
});
